import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import MediaQuery from "components/MediaQuery";
import FullRuneTree from "components/common/RuneTrees/FullRuneTree";
import { getPercetange, numberWithCommas } from "lib/general-helper";
import { getRoleLabel } from "lib/role_helper";

const Runes = (props) => {
  const { t } = useTranslation();
  const { statShards, recRunes, patch, championName, role, multi } = props;

  const firstSpanRef = useRef(null);
  const secondSpanRef = useRef(null);

  useEffect(() => {
    const firstSpan = firstSpanRef.current;
    const secondSpan = secondSpanRef.current;

    const combinedWidth = firstSpan.offsetWidth + secondSpan.offsetWidth;

    if (combinedWidth > 309) {
      secondSpan.textContent = `...${getRoleLabel(role)} Build`;
    }
  });

  function capitalizeMulti(multi) {
    switch (multi) {
      case "ap":
      case "ad":
        return multi.toUpperCase();
      case "tank":
      case "crit":
      case "lethality":
        return multi.substring(0, 1).toUpperCase() + multi.substring(1);
      case "onhit":
        return "On Hit";
      case "red":
        return "Red";
      case "blue":
        return "Blue";
    }
  }

  return (
    <div className="content-section_content recommended-build_runes">
      <div className="content-section_header">
        <div className="main-header">
          <span style={{ marginRight: 12 }} ref={firstSpanRef}>
            {multi ? `${capitalizeMulti(multi)} ${championName} ${t("Runes")}` : `${championName} ${t("Runes")}`}
          </span>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <span className="content-section_blurb" ref={secondSpanRef}>
              {multi
                ? `${capitalizeMulti(multi)} ${championName} ${getRoleLabel(role)} Build`
                : `${championName} ${getRoleLabel(role)} Build`}
            </span>
          </MediaQuery>
        </div>
        <div className="wr-matches">
          <span className={"win-rate"}>{`${getPercetange(recRunes.wins, recRunes.matches, 2)}% WR `}</span>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <span className="matches">{`(${numberWithCommas(recRunes.matches)} Matches)`}</span>
          </MediaQuery>
        </div>
      </div>
      <div>
        <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
          <FullRuneTree
            primaryStyle={recRunes.primary_style}
            subStyle={recRunes.sub_style}
            activePerks={recRunes.active_perks}
            activeShards={statShards?.activeShards}
            patch={patch}
            ssr
          />
        </MediaQuery>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
          <FullRuneTree
            primaryStyle={recRunes.primary_style}
            subStyle={recRunes.sub_style}
            activePerks={recRunes.active_perks}
            activeShards={statShards?.activeShards}
            patch={patch}
            ssr
            isMobile
          />
        </MediaQuery>
      </div>
    </div>
  );
};

export default Runes;
